module.exports = ".content.theme-blue .side-nav, .content.theme-blue .theme-toolbar {\n  background-color: #292955;\n  border-bottom: 1px solid #292955; }\n\n.content.theme-blue .theme-toolbar {\n  color: white; }\n\n.content.theme-blue .content-box .form-group label, .content.theme-blue .footer {\n  color: #292955 !important; }\n\n.theme-blue .form-group label {\n  color: #292955 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/khb.component.scss
// module id = ./src/app/khb.component.scss
// module chunks = main